import React, { useState } from 'react';
import DibujarPredio from './DibujarPredio';

const API = process.env.REACT_APP_API_URL;

// Un único plan, precio plano. Debe coincidir con satfire-backend/src/services/pricing.js
const PRECIO_MENSUAL = 13900;   // CLP, IVA incluido

function FormAgregarParcela({ token, dm, onAgregado, onCancelar, usuario }) {
  const [nombre, setNombre]       = useState('');
  const [telefono, setTelefono]   = useState(usuario?.telefono || '');
  const [poligono, setPoligono]   = useState(null);
  const [superaMax, setSuperaMax] = useState(false);
  const [cargando, setCargando]   = useState(false);
  const [error, setError]         = useState('');

  const inp = {
    width: '100%', padding: '9px 12px', border: '1.5px solid ' + dm.border,
    borderRadius: 9, fontSize: 13, background: dm.bg, color: dm.text,
    fontFamily: 'Inter, sans-serif', outline: 'none', boxSizing: 'border-box',
  };

  const guardar = async () => {
    if (!nombre.trim()) return setError('Ingresa un nombre para la parcela.');
    if (!poligono) return setError('Dibuja el contorno de tu parcela en el mapa (al menos 3 esquinas).');
    if (superaMax) return setError('Tu propiedad supera las 8 ha — escríbenos a contacto@montaraz.cl para un plan a medida.');

    setCargando(true); setError('');
    try {
      const res = await fetch(API + '/api/cliente/predios', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token },
        body: JSON.stringify({ nombre, poligono, radio_alerta_km: 15, telefono: telefono || undefined }),
      });
      const data = await res.json();
      if (!data.ok) return setError(data.error || 'Error al crear parcela');
      onAgregado(data.predio);
    } catch { setError('Error de conexión'); }
    finally { setCargando(false); }
  };

  return (
    <div style={{ marginTop: 12 }}>
      <div style={{ fontWeight: 700, fontSize: 13, color: dm.text, marginBottom: 10 }}>Nueva parcela</div>

      <input placeholder="Nombre (ej: Fundo Los Boldos)" value={nombre}
        onChange={e => setNombre(e.target.value)} style={{ ...inp, marginBottom: 8 }} />

      <input placeholder="WhatsApp para alertas (ej: +56912345678)" value={telefono}
        onChange={e => setTelefono(e.target.value)} style={{ ...inp, marginBottom: 10 }} />

      <DibujarPredio
        dm={dm}
        altura={200}
        onChange={({ poligono: p, superaMax: s }) => { setPoligono(p); setSuperaMax(s); }}
      />

      {poligono && !superaMax && (
        <div style={{ background: dm.accentLight, border: '1px solid ' + dm.border, borderRadius: 9, padding: '8px 12px', margin: '4px 0 8px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <span style={{ fontSize: 12, color: dm.muted }}>Plan Mensual</span>
          <span style={{ fontSize: 14, fontWeight: 700, color: dm.accent }}>${PRECIO_MENSUAL.toLocaleString('es-CL')}/mes</span>
        </div>
      )}

      {error && (
        <div style={{ background: '#fff0f0', color: '#c53030', padding: '7px 10px', borderRadius: 8, fontSize: 12, marginBottom: 8, border: '1px solid #feb2b2' }}>
          {error}
        </div>
      )}

      <div style={{ display: 'flex', gap: 8 }}>
        <button onClick={onCancelar} style={{
          flex: 1, padding: '9px', background: 'none', border: '1.5px solid ' + dm.border,
          borderRadius: 9, fontSize: 13, color: dm.muted, cursor: 'pointer', fontFamily: 'Inter, sans-serif',
        }}>Cancelar</button>
        <button onClick={guardar} disabled={cargando || !poligono || superaMax} style={{
          flex: 2, padding: '9px', background: dm.accent, color: 'white',
          border: 'none', borderRadius: 9, fontSize: 13, fontWeight: 600,
          cursor: cargando ? 'not-allowed' : 'pointer', opacity: (cargando || !poligono || superaMax) ? .6 : 1,
          fontFamily: 'Inter, sans-serif',
        }}>{cargando ? 'Guardando...' : 'Guardar parcela'}</button>
      </div>
    </div>
  );
}

export default function Perfil({ usuario, token, onClose, dm, predios = [], onPredioAgregado, onPredioEliminado }) {
  const [tab, setTab]               = useState('parcelas');
  const [enviando, setEnviando]     = useState(false);
  const [mensajeWA, setMensajeWA]   = useState('');
  const [agregando, setAgregando]   = useState(false);
  const [eliminando, setEliminando] = useState(null);
  const [editandoTel, setEditandoTel] = useState(null);
  const [telValor, setTelValor]       = useState('');
  const [guardandoTel, setGuardandoTel] = useState(false);
  const [cancelandoSus, setCancelandoSus] = useState(false);
  const [avisoCancelacion, setAvisoCancelacion] = useState('');

  // Contactos adicionales por predio
  const [contactosPredio, setContactosPredio] = useState({}); // { [predio_id]: [...] }
  const [cargandoContactos, setCargandoContactos] = useState({});
  const [agregandoContacto, setAgregandoContacto] = useState(null); // predio_id
  const [nuevoContacto, setNuevoContacto] = useState({ nombre: '', telefono: '', rol: '' });
  const [guardandoContacto, setGuardandoContacto] = useState(false);
  const [errorContacto, setErrorContacto] = useState('');

  const cargarContactos = async (predioId) => {
    if (contactosPredio[predioId] !== undefined) return;
    setCargandoContactos(p => ({ ...p, [predioId]: true }));
    try {
      const r = await fetch(`${API}/api/cliente/predios/${predioId}/contactos`, {
        headers: { Authorization: 'Bearer ' + token },
      });
      const data = await r.json();
      setContactosPredio(p => ({ ...p, [predioId]: data.contactos || [] }));
    } catch {}
    finally { setCargandoContactos(p => ({ ...p, [predioId]: false })); }
  };

  const agregarContacto = async (predioId) => {
    if (!nuevoContacto.nombre || !nuevoContacto.telefono) return setErrorContacto('Nombre y teléfono requeridos');
    setGuardandoContacto(true); setErrorContacto('');
    try {
      const r = await fetch(`${API}/api/cliente/predios/${predioId}/contactos`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Authorization: 'Bearer ' + token },
        body: JSON.stringify(nuevoContacto),
      });
      const data = await r.json();
      if (!data.ok) return setErrorContacto(data.error || 'Error al agregar');
      setContactosPredio(p => ({ ...p, [predioId]: [...(p[predioId] || []), data.contacto] }));
      setAgregandoContacto(null);
      setNuevoContacto({ nombre: '', telefono: '', rol: '' });
    } catch { setErrorContacto('Error de conexión'); }
    finally { setGuardandoContacto(false); }
  };

  const eliminarContacto = async (predioId, contactoId) => {
    try {
      await fetch(`${API}/api/cliente/predios/${predioId}/contactos/${contactoId}`, {
        method: 'DELETE', headers: { Authorization: 'Bearer ' + token },
      });
      setContactosPredio(p => ({ ...p, [predioId]: p[predioId].filter(c => c.id !== contactoId) }));
    } catch {}
  };

  const guardarTelefono = async (predioId) => {
    setGuardandoTel(true);
    try {
      await fetch(API + '/api/cliente/predios/' + predioId, {
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json', Authorization: 'Bearer ' + token },
        body: JSON.stringify({ telefono: telValor }),
      });
      onPredioEliminado?.(); // reutilizamos para recargar
    } catch {}
    setGuardandoTel(false);
    setEditandoTel(null);
  };

  const cancelarSuscripcion = async () => {
    if (!window.confirm('¿Cancelar la renovación automática? Seguirás recibiendo alertas hasta el final del período ya pagado, y después no se te cobrará ni recibirás alertas.')) return;
    setCancelandoSus(true); setAvisoCancelacion('');
    try {
      const res = await fetch(API + '/api/pagos/cancelar', {
        method: 'POST', headers: { Authorization: 'Bearer ' + token },
      });
      const data = await res.json();
      if (data.ok) {
        const fecha = data.vigente_hasta ? new Date(data.vigente_hasta).toLocaleDateString('es-CL') : null;
        setAvisoCancelacion(fecha
          ? `✅ Renovación cancelada. Seguirás recibiendo alertas hasta el ${fecha}; después no se te cobrará ni recibirás alertas.`
          : '✅ Renovación cancelada.');
        onPredioEliminado?.(); // reutilizamos para recargar y reflejar que ya no hay flow_subscription_id
      } else {
        setAvisoCancelacion('❌ ' + (data.error || 'No se pudo cancelar la suscripción'));
      }
    } catch { setAvisoCancelacion('❌ Error de conexión'); }
    finally { setCancelandoSus(false); }
  };

  const testWhatsApp = async () => {
    setEnviando(true); setMensajeWA('');
    try {
      const res = await fetch(API + '/api/cliente/test-whatsapp', {
        method: 'POST', headers: { Authorization: 'Bearer ' + token },
      });
      const data = await res.json();
      setMensajeWA(data.ok
        ? '✅ ' + data.mensaje + '. Revisa tu WhatsApp.'
        : '❌ ' + (data.error || 'Error al enviar'));
    } catch { setMensajeWA('❌ Error de conexión'); }
    finally { setEnviando(false); }
  };

  const eliminarPredio = async (id) => {
    if (!window.confirm('¿Eliminar esta parcela?')) return;
    setEliminando(id);
    try {
      const res = await fetch(API + '/api/cliente/predios/' + id, {
        method: 'DELETE', headers: { Authorization: 'Bearer ' + token },
      });
      const data = await res.json();
      if (data.ok) onPredioEliminado?.(id);
    } catch { }
    finally { setEliminando(null); }
  };

  const TABS = [
    { id: 'parcelas', label: 'Mis parcelas' },
    { id: 'cuenta',   label: 'Cuenta' },
    { id: 'wa',       label: 'WhatsApp' },
  ];

  const segBtn = (id) => ({
    flex: 1, padding: '7px 4px', border: 'none', borderRadius: 8, cursor: 'pointer',
    fontFamily: 'Inter, sans-serif', fontSize: 12, fontWeight: 600, transition: 'all .15s',
    background: tab === id ? dm.accent : 'transparent',
    color: tab === id ? 'white' : dm.muted,
  });

  const row = { display: 'flex', justifyContent: 'space-between', alignItems: 'center' };

  return (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', zIndex: 100, display: 'flex', alignItems: 'center', justifyContent: 'center', fontFamily: 'Inter, sans-serif', padding: 16 }}>
      <div style={{ background: dm.card, borderRadius: 20, padding: '24px 24px 20px', width: '100%', maxWidth: 500, boxShadow: '0 24px 64px rgba(0,0,0,0.3)', border: '1px solid ' + dm.border, maxHeight: '90vh', overflowY: 'auto' }}>

        {/* Header */}
        <div style={{ ...row, marginBottom: 16 }}>
          <div style={{ fontSize: 17, fontWeight: 700, color: dm.text }}>Mi perfil</div>
          <button onClick={onClose} style={{ background: 'none', border: 'none', fontSize: 18, cursor: 'pointer', color: dm.muted, lineHeight: 1 }}>✕</button>
        </div>

        {/* Tabs */}
        <div style={{ display: 'flex', background: dm.bg, border: '1px solid ' + dm.border, borderRadius: 10, padding: 3, marginBottom: 20, gap: 2 }}>
          {TABS.map(t => (
            <button key={t.id} onClick={() => { setTab(t.id); setAgregando(false); }} style={segBtn(t.id)}>
              {t.label}
            </button>
          ))}
        </div>

        {/* ── TAB: MIS PARCELAS ── */}
        {tab === 'parcelas' && (
          <div>
            {predios.length === 0 ? (
              <div style={{ textAlign: 'center', padding: '20px 0', color: dm.muted, fontSize: 13 }}>
                No tienes parcelas registradas.
              </div>
            ) : predios.map(p => (
              <div key={p.id} style={{ background: dm.bg, border: '1px solid ' + dm.border, borderRadius: 12, padding: '12px 14px', marginBottom: 8 }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                  <div style={{ flex: 1 }}>
                    <div style={{ fontWeight: 700, fontSize: 14, color: dm.text }}>{p.nombre}</div>
                    <div style={{ fontSize: 11, color: dm.muted, marginTop: 3 }}>
                      {p.superficie_m2 ? (p.superficie_m2/10000) + ' ha' : 'Sin superficie'} · {p.radio_alerta_km || 15} km radio
                    </div>
                    {(() => {
                      const vigente = p.vigente_hasta && new Date(p.vigente_hasta) > new Date();
                      const seRenueva = vigente && !!p.flow_subscription_id;
                      return (
                        <div style={{ fontSize: 11, marginTop: 4 }}>
                          <span style={{ background: vigente ? dm.accentLight : '#fff8e8', color: vigente ? dm.accent : '#b7791f', padding: '2px 7px', borderRadius: 99, fontWeight: 600, border: '1px solid ' + (vigente ? dm.border : '#d69e2e') }}>
                            {vigente ? (seRenueva ? '✓ Activa' : '✓ Activa · no se renueva') : p.plan_id ? 'Vencida' : 'Sin suscripción'}
                          </span>
                          {vigente && (
                            <span style={{ color: dm.muted, marginLeft: 6 }}>
                              vence el {new Date(p.vigente_hasta).toLocaleDateString('es-CL')}
                            </span>
                          )}
                        </div>
                      );
                    })()}
                  </div>
                  <button onClick={() => eliminarPredio(p.id)} disabled={eliminando === p.id}
                    style={{ background: 'none', border: '1px solid ' + dm.border, borderRadius: 7, padding: '4px 8px', cursor: 'pointer', fontSize: 11, color: '#c53030', opacity: eliminando === p.id ? .5 : 1, flexShrink: 0, marginLeft: 8 }}>
                    {eliminando === p.id ? '...' : 'Eliminar'}
                  </button>
                </div>

                {/* Teléfono principal */}
                <div style={{ marginTop: 10, paddingTop: 10, borderTop: '1px solid ' + dm.border + '66' }}>
                  <div style={{ fontSize: 11, color: dm.muted, marginBottom: 5 }}>📱 WhatsApp principal</div>
                  {editandoTel === p.id ? (
                    <div style={{ display: 'flex', gap: 6 }}>
                      <input value={telValor} onChange={e => setTelValor(e.target.value)}
                        placeholder="+56912345678" autoFocus
                        onKeyDown={e => { if (e.key === 'Enter') guardarTelefono(p.id); if (e.key === 'Escape') setEditandoTel(null); }}
                        style={{ flex: 1, padding: '6px 10px', border: '1.5px solid ' + dm.accent, borderRadius: 8, fontSize: 12, background: dm.bg, color: dm.text, fontFamily: 'Inter, sans-serif', outline: 'none' }} />
                      <button onClick={() => guardarTelefono(p.id)} disabled={guardandoTel}
                        style={{ padding: '6px 10px', background: dm.accent, color: 'white', border: 'none', borderRadius: 8, fontSize: 12, fontWeight: 600, cursor: 'pointer', fontFamily: 'Inter, sans-serif' }}>
                        {guardandoTel ? '...' : 'Guardar'}
                      </button>
                      <button onClick={() => setEditandoTel(null)}
                        style={{ padding: '6px 8px', background: 'none', border: '1px solid ' + dm.border, borderRadius: 8, fontSize: 12, color: dm.muted, cursor: 'pointer' }}>✕</button>
                    </div>
                  ) : (
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                      <span style={{ fontSize: 13, fontWeight: 600, color: p.telefono ? dm.text : '#c53030' }}>
                        {p.telefono || '⚠️ Sin teléfono — no recibirás alertas'}
                      </span>
                      <button onClick={() => { setEditandoTel(p.id); setTelValor(p.telefono || ''); }}
                        style={{ background: 'none', border: '1px solid ' + dm.border, borderRadius: 7, padding: '3px 8px', cursor: 'pointer', fontSize: 11, color: dm.accent, marginLeft: 8, fontFamily: 'Inter, sans-serif' }}>
                        Editar
                      </button>
                    </div>
                  )}
                </div>

                {/* Contactos adicionales */}
                <div style={{ marginTop: 10, paddingTop: 10, borderTop: '1px solid ' + dm.border + '66' }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 6 }}>
                    <div style={{ fontSize: 11, color: dm.muted }}>👥 Contactos adicionales (máx. 2)</div>
                    {(contactosPredio[p.id] || []).length < 2 && (
                      <button
                        onClick={() => { cargarContactos(p.id); setAgregandoContacto(agregandoContacto === p.id ? null : p.id); setNuevoContacto({ nombre: '', telefono: '', rol: '' }); setErrorContacto(''); }}
                        style={{ fontSize: 11, color: dm.accent, background: 'none', border: '1px solid ' + dm.border, borderRadius: 7, padding: '2px 8px', cursor: 'pointer', fontFamily: 'Inter, sans-serif' }}>
                        {agregandoContacto === p.id ? '✕ Cancelar' : '+ Agregar'}
                      </button>
                    )}
                  </div>

                  {cargandoContactos[p.id] && <div style={{ fontSize: 11, color: dm.muted }}>Cargando...</div>}

                  {(contactosPredio[p.id] || []).map(c => (
                    <div key={c.id} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '5px 8px', background: dm.accentLight, borderRadius: 7, marginBottom: 4 }}>
                      <div>
                        <span style={{ fontSize: 12, fontWeight: 600, color: dm.text }}>{c.nombre}</span>
                        {c.rol && <span style={{ fontSize: 10, color: dm.muted, marginLeft: 6 }}>{c.rol}</span>}
                        <div style={{ fontSize: 11, color: dm.muted }}>{c.telefono}</div>
                      </div>
                      <button onClick={() => eliminarContacto(p.id, c.id)}
                        style={{ fontSize: 10, color: '#c53030', background: 'none', border: 'none', cursor: 'pointer', padding: '2px 4px' }}>✕</button>
                    </div>
                  ))}

                  {agregandoContacto === p.id && (
                    <div style={{ marginTop: 8, padding: '10px', background: dm.bg, border: '1px solid ' + dm.border, borderRadius: 9 }}>
                      <input placeholder="Nombre (ej: Capataz Pedro)" value={nuevoContacto.nombre}
                        onChange={e => setNuevoContacto(n => ({ ...n, nombre: e.target.value }))}
                        style={{ width: '100%', padding: '7px 10px', border: '1.5px solid ' + dm.border, borderRadius: 8, fontSize: 12, background: dm.card, color: dm.text, fontFamily: 'Inter, sans-serif', outline: 'none', boxSizing: 'border-box', marginBottom: 6 }} />
                      <input placeholder="WhatsApp (+56912345678)" value={nuevoContacto.telefono}
                        onChange={e => setNuevoContacto(n => ({ ...n, telefono: e.target.value }))}
                        style={{ width: '100%', padding: '7px 10px', border: '1.5px solid ' + dm.border, borderRadius: 8, fontSize: 12, background: dm.card, color: dm.text, fontFamily: 'Inter, sans-serif', outline: 'none', boxSizing: 'border-box', marginBottom: 6 }} />
                      <input placeholder="Rol (ej: Encargado, Guardia) — opcional" value={nuevoContacto.rol}
                        onChange={e => setNuevoContacto(n => ({ ...n, rol: e.target.value }))}
                        style={{ width: '100%', padding: '7px 10px', border: '1.5px solid ' + dm.border, borderRadius: 8, fontSize: 12, background: dm.card, color: dm.text, fontFamily: 'Inter, sans-serif', outline: 'none', boxSizing: 'border-box', marginBottom: 6 }} />
                      {errorContacto && <div style={{ fontSize: 11, color: '#c53030', marginBottom: 6 }}>{errorContacto}</div>}
                      <button onClick={() => agregarContacto(p.id)} disabled={guardandoContacto}
                        style={{ width: '100%', padding: '7px', background: dm.accent, color: 'white', border: 'none', borderRadius: 8, fontSize: 12, fontWeight: 600, cursor: 'pointer', fontFamily: 'Inter, sans-serif', opacity: guardandoContacto ? .7 : 1 }}>
                        {guardandoContacto ? 'Guardando...' : 'Guardar contacto'}
                      </button>
                    </div>
                  )}
                </div>
              </div>
            ))}

            {predios.length > 0 ? (
              <div style={{ marginTop: 4, padding: '12px 14px', background: dm.bg, border: '1px solid ' + dm.border, borderRadius: 10, fontSize: 12, color: dm.muted, lineHeight: 1.6 }}>
                ¿Necesitas monitorear una propiedad más grande o varias propiedades? Escríbenos a{' '}
                <a href="mailto:contacto@montaraz.cl" style={{ color: dm.accent, fontWeight: 600 }}>contacto@montaraz.cl</a>{' '}
                y preparamos un plan a medida.
              </div>
            ) : !agregando ? (
              <button
                onClick={() => setAgregando(true)}
                style={{ width: '100%', marginTop: 4, padding: '10px', background: dm.accentLight, border: '1.5px dashed ' + dm.accent, borderRadius: 10, fontSize: 13, fontWeight: 600, color: dm.accent, cursor: 'pointer', fontFamily: 'Inter, sans-serif' }}
              >
                + Agregar parcela
              </button>
            ) : (
              <FormAgregarParcela
                token={token}
                dm={dm}
                usuario={usuario}
                onAgregado={(predio) => { setAgregando(false); onPredioAgregado?.(predio); }}
                onCancelar={() => setAgregando(false)}
              />
            )}
          </div>
        )}

        {/* ── TAB: CUENTA ── */}
        {tab === 'cuenta' && (
          <div style={{ background: dm.bg, borderRadius: 12, padding: '14px 16px', border: '1px solid ' + dm.border }}>
            <div style={{ fontSize: 10, color: dm.muted, textTransform: 'uppercase', letterSpacing: '1px', marginBottom: 10 }}>Datos de la cuenta</div>
            {[
              { label: 'Nombre',   valor: usuario.nombre },
              { label: 'Email',    valor: usuario.email },
              { label: 'WhatsApp', valor: predios[0]?.telefono || 'No registrado' },
              { label: 'Plan',     valor: usuario.plan, accent: true },
            ].map(d => (
              <div key={d.label} style={{ ...row, paddingBottom: 8, marginBottom: 8, borderBottom: '1px solid ' + dm.border + '55' }}>
                <span style={{ fontSize: 13, color: dm.muted }}>{d.label}</span>
                <span style={{ fontSize: 13, fontWeight: 600, color: d.accent ? dm.accent : dm.text }}>{d.valor}</span>
              </div>
            ))}

            {predios[0]?.vigente_hasta && new Date(predios[0].vigente_hasta) > new Date() && predios[0]?.flow_subscription_id && (
              <div style={{ textAlign: 'center', marginTop: 4 }}>
                <button onClick={cancelarSuscripcion} disabled={cancelandoSus} style={{
                  background: 'none', border: 'none', padding: 0, fontSize: 11.5, color: dm.muted,
                  textDecoration: 'underline', cursor: cancelandoSus ? 'not-allowed' : 'pointer', fontFamily: 'Inter, sans-serif',
                }}>
                  {cancelandoSus ? 'Cancelando...' : 'Cancelar suscripción'}
                </button>
              </div>
            )}
            {avisoCancelacion && (
              <div style={{ marginTop: 8, fontSize: 11.5, textAlign: 'center', color: avisoCancelacion.startsWith('✅') ? dm.accent : '#c53030', lineHeight: 1.5 }}>
                {avisoCancelacion}
              </div>
            )}
          </div>
        )}

        {/* ── TAB: WHATSAPP ── */}
        {tab === 'wa' && (
          <div>
            <div style={{ background: dm.bg, borderRadius: 12, padding: '14px 16px', border: '1px solid ' + dm.border, marginBottom: 12 }}>
              <div style={{ fontSize: 10, color: dm.muted, textTransform: 'uppercase', letterSpacing: '1px', marginBottom: 8 }}>Verificar alertas</div>
              <div style={{ fontSize: 12, color: dm.subtext, marginBottom: 14, lineHeight: 1.6 }}>
                Envía un mensaje de prueba para confirmar que las alertas llegarán correctamente a tu número.
              </div>
              <div style={{ ...row, marginBottom: 12 }}>
                <span style={{ fontSize: 13, color: dm.muted }}>Número</span>
                <span style={{ fontSize: 13, fontWeight: 600, color: dm.text }}>{predios[0]?.telefono || 'No registrado'}</span>
              </div>
              <button onClick={testWhatsApp} disabled={enviando || !predios[0]?.telefono} style={{
                width: '100%', padding: '10px', background: '#25D366', color: 'white',
                border: 'none', borderRadius: 10, fontSize: 13, fontWeight: 600,
                cursor: enviando || !predios[0]?.telefono ? 'not-allowed' : 'pointer',
                opacity: enviando || !predios[0]?.telefono ? 0.6 : 1, fontFamily: 'Inter, sans-serif',
              }}>
                {enviando ? 'Enviando...' : '💬 Enviar mensaje de prueba'}
              </button>
              {!predios[0]?.telefono && (
                <div style={{ fontSize: 11, color: '#dd6b20', marginTop: 6, textAlign: 'center' }}>
                  No tienes teléfono registrado en tu parcela
                </div>
              )}
              {mensajeWA && (
                <div style={{ fontSize: 12, color: mensajeWA.includes('✅') ? '#38a169' : '#c53030', marginTop: 8, textAlign: 'center', fontWeight: 600 }}>
                  {mensajeWA}
                </div>
              )}
            </div>
          </div>
        )}

        <button onClick={onClose} style={{ width: '100%', marginTop: 16, padding: '9px', background: dm.bg, border: '1px solid ' + dm.border, borderRadius: 10, fontSize: 13, color: dm.muted, cursor: 'pointer', fontFamily: 'Inter, sans-serif' }}>
          Cerrar
        </button>
      </div>
    </div>
  );
}
